import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isFeedbackShow:false,
    currentNum:1,//当前页
  },
  mutations: {
    UPSTATAFEEDBACK(state,payload){
      state.isFeedbackShow=payload
    },
    CURRENTNUM(state,payload){
      state.currentNum=payload
    }
  },
  actions: {
  },
  modules: {
  }
})
